export default __webpack_public_path__ + "static/media/terms-of-service-consent-en-0.a1b17efd.jpg";